/**
 * Panic Button View
 */
define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var server = require('server');
    var user = require('user');

    module.exports = BaseReplacerView.extend({

        selfExcludeTime: null,

        events: {
            'tap .fn-show-panic-btn-popup': 'showPanicPopup',
            'tap .fn-accept': 'submitDialog'
        },

        initialize: function() {
            if (!user.isLoggedIn()) {
                return;
            }

            this.getPanicButtonConfig()
                .done(this.handleConfigSuccess.bind(this));
        },

        getPanicButtonConfig: function() {
            return server.send({
                ID: 35674,
                description: 'Get Panic Button Configuration',
                correlationId: String(Math.random()).slice(2),
                responses: [35675, 35676]
            });
        },

        handleConfigSuccess: function(resp) {
            var data = resp.data || {};

            this.selfExcludeTime = data.selfExcludeTime;
            this.renderButton(!data.enabled);
        },

        renderButton: function(disabled) {
            this.el.innerHTML = disabled ? '' : this.tmpl('panic-button');
        },

        showPanicPopup: function() {
            window.Playtech.API.popup.showPopup('confirmation', {
                title: 'playtech.mobile.system.panicBtn.popup.title',
                content: this.translate('playtech.mobile.system.panicBtn.popup.content', this.selfExcludeTime),
                onAccept: this.acceptPanicBtnPopup.bind(this),
                acceptBtnText: 'playtech.mobile.system.panicBtn.popup.accept',
                declineBtnText: 'playtech.mobile.system.panicBtn.popup.cancel'
            });
        },

        acceptPanicBtnPopup: function() {
            this.submitDialog()
                .done(this.handleSuccessDialogPopup.bind(this))
                .fail(this.handleErrorDialogPopup.bind(this));
        },

        submitDialog: function() {
            return server.send({
                ID: 89919,
                description: 'Panic Button Submit Dialog',
                responses: [89920]
            });
        },

        handleSuccessDialogPopup: function(resp) {
            var data = resp.data || {};

            window.Playtech.API.popup.showPopup({
                title: 'playtech.mobile.system.panicBtn.status.popup.title.success',
                content: data.message
            });
        },

        handleErrorDialogPopup: function() {
            window.Playtech.API.popup.showPopup({
                title: 'playtech.mobile.system.panicBtn.status.popup.title.error',
                content: this.translate('playtech.mobile.system.panicBtn.status.popup.content.error')
            });
        }
    }, {
        nameOfReplacers: ['RG_PANIC']
    });
});
